var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125.547,
    height: 125.563,
    viewBox: "0 0 125.547 125.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-double",
    "data-name": "Icon awesome-check-double",
    d: "M123.836,42.866l-9.71-9.71a5.861,5.861,0,0,0-8.312,0L47.088,91.882,19.772,64.542a5.861,5.861,0,0,0-8.312,0L1.725,74.276a5.89,5.89,0,0,0,0,8.337l41.194,41.219a5.861,5.861,0,0,0,8.312,0L123.812,51.2A5.912,5.912,0,0,0,123.836,42.866ZM44.317,68.857a3.893,3.893,0,0,0,5.542,0l51-51.051a3.937,3.937,0,0,0,0-5.542L89.778,1.157a3.893,3.893,0,0,0-5.542,0L47.088,38.305,33.5,24.7a3.893,3.893,0,0,0-5.542,0L16.854,35.8a3.937,3.937,0,0,0,0,5.542Z",
    transform: "translate(0.004 0.002)",
    fill: "#0fd16a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.da0843fce6725fc44792264e74d4ef26.svg";
export { ForwardRef as ReactComponent };